import { render, staticRenderFns } from "./Step3VotingRight.vue?vue&type=template&id=04a5b3da&scoped=true&"
import script from "./Step3VotingRight.vue?vue&type=script&lang=js&"
export * from "./Step3VotingRight.vue?vue&type=script&lang=js&"
import style0 from "./Step3VotingRight.vue?vue&type=style&index=0&id=04a5b3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a5b3da",
  null
  
)

export default component.exports